import { render, staticRenderFns } from "./buyback.vue?vue&type=template&id=dffd6bb6&"
import script from "./buyback.vue?vue&type=script&lang=js&"
export * from "./buyback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports